import {
    createAsyncThunk,
    createSlice,
} from '@reduxjs/toolkit';

import {
    add,
    deleteRecord,
    fetch,
    fetchRecords,
    update,
} from '../services/AccountApplicationsService.ts';


import {
    deleteOneCase,
    fetchManyWithTokenPaginationCase,
    fetchOneCase,
    saveOneCase,
    updateOneCase,
} from '../../../../store/RecordsSliceCaseHelpers';
import {AccountApplication} from '../types';

const entityKey = 'accountApplications';

interface AccountApplicationsState {
    byId: { [key: string]: AccountApplication },
    ids: string[],
    totalCount: number,
    loading: boolean,
    error: string
}

const initialState = {
    byId: {},
    ids: [],
    totalCount: 0,
    loading: false,
    error: '',
} as AccountApplicationsState;


const normalizeRecord = (record: AccountApplication) => {
    return Object.assign({}, record);
};

// generates pending, fulfilled and rejected
export const fetchAccountApplications = createAsyncThunk(
    `${entityKey}/fetchRecords`,
    ({
         accountId
     }: {
        accountId: string
    }) => {

        console.log('fetchAccountApplications', accountId);

        return fetchRecords({accountId: accountId})
            .then((response) => response)

    },
);

export const fetchAccountApplication = createAsyncThunk(
    `${entityKey}/fetch`,
    ({
         id
     }: { id: string }) => {
        return fetch(id)
            .then((response) => response);
    });

export const saveAccountApplication = createAsyncThunk(
    `${entityKey}/add`,
    ({
         payload
     }: {
        payload: AccountApplication
    }) => {

        return add(payload)
            .then((response) => response);
    });

export const updateAccountApplication = createAsyncThunk(
    `${entityKey}/update`,
    ({
         id,
         record,
     }: { id: string, record: AccountApplication }) => {

        return update(id, record)
            .then((response) => {
                if (response) {
                    return response;
                }
            });
    },
);

export const deleteAccountApplication = createAsyncThunk(
    `${entityKey}/deleteRecord`,
    ({
         id
     }: {
        id: string
    }) => {

        return deleteRecord(id)
            .then(() => id);
    },
);


export const storeAccountApplication = createAsyncThunk(
    `${entityKey}/store`,
    (payload: AccountApplication) => {
        return normalizeRecord(payload);
    },
);


const componentsSlice = createSlice({
                                        name: entityKey,
                                        initialState,
                                        reducers: {
                                            clearState: () => initialState,
                                        },
                                        extraReducers: (builder) => {
                                            // FETCH MANY
                                            fetchManyWithTokenPaginationCase(builder, fetchAccountApplications, entityKey);

                                            // FETCH ONE
                                            fetchOneCase(builder, fetchAccountApplication);

                                            // SAVE ONE
                                            saveOneCase(builder, saveAccountApplication);

                                            // UPDATE ONE
                                            updateOneCase(builder, updateAccountApplication);

                                            updateOneCase(builder, storeAccountApplication);

                                            // DELETE ONE
                                            deleteOneCase(builder, deleteAccountApplication);
                                        },
                                    });

export default componentsSlice.reducer;
